import { Button } from "@/components/ui/button";
import { Link } from "@/components/link";
import { ExternalLink } from "lucide-react";
import { useTranslation } from "react-i18next";
import { generatePath } from "react-router-dom";

export interface DetailsButtonProps {
  path: string;
  pathParams: Record<string, string | number | null | undefined>;
  label: string;
}

export function DetailsButton({ path, pathParams, label }: DetailsButtonProps) {
  const { t } = useTranslation();
  return (
    <Button variant="secondary" type="button" asChild>
      <Link to={generatePath(path, pathParams)}>
        {t(label)}
        <ExternalLink className="w-4 h-4" />
      </Link>
    </Button>
  );
}
